import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
var GlobalModalContext = /*#__PURE__*/ createContext(undefined);
export var GlobalModalProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState({
        visible: false,
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        subTitle: "รหัส 500",
        btnText: "ตกลง",
        navigateDirection: undefined
    }), 2), modalObj = _useState[0], setModalObj = _useState[1];
    var contextValue = {
        modalObj: modalObj,
        setModalObj: setModalObj
    };
    return /*#__PURE__*/ _jsx(GlobalModalContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useGlobalModalContext = function() {
    var context = useContext(GlobalModalContext);
    if (!context) {
        throw new Error("useGlobalModalContext must be used within an ErrorProvider");
    }
    return context;
};
